import { render, staticRenderFns } from "./fitment-add-edit.vue?vue&type=template&id=876418c0&scoped=true&"
import script from "./fitment-add-edit.vue?vue&type=script&lang=js&"
export * from "./fitment-add-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876418c0",
  null
  
)

export default component.exports